import { Platform } from 'react-native';

/**
 * The iPhone app — by device IDIOM, never by window size (#684, #679).
 *
 * The phone keeps the pre-v2 shape: Home is the work-order list and the drawer holds only Work
 * Orders and Settings. The iPad and every web window keep the v2 dashboard and sidebar, so this
 * is the ONE predicate both Home and the drawer branch on.
 *
 * Not `useDeviceInfo().isPhone`: that is window-based, so an iPad mini in portrait (744pt) or
 * any iPad in Split View / Slide Over read as a phone, and rotating or dragging the divider
 * swapped the whole shell mid-session. `Platform.isPad` is fixed for the session. Window size
 * stays the right input for LAYOUT (columns, drawer type) — just not for which app this is.
 * Android is not a target.
 */
export const useIsNativePhone = (): boolean => Platform.OS === 'ios' && !Platform.isPad;
